<p-toast></p-toast>
<div class="mw-100">
    <app-navbar></app-navbar>
    <div class="row custCont">
        <div class="container">
            <p-card *ngIf="index===0">
                <ng-template pTemplate="header">
                </ng-template>
                <div class="row taC">
                        <!-- <img src="assets/download.svg" class="imgSize" />
                        <h5 class="headingFont mT-15">Conectar un nuevo dispositivo</h5>
                        <h5 class="subHeading">Este proceso emparejará un número de WhatsApp existente con la plataforma en
                            unos minutos.</h5> -->
                    <h5 class="head1 mT-15">{{ 'ALIAS' | translate}}</h5>
                    <input type="username" class="inputfiled" pInputText [(ngModel)]="nombre"/>
                    <h6 class="subhead">{{ 'ADD_ALIAS' | translate}}.</h6>
                    <p-checkbox [(ngModel)]="checkedTerm" [binary]="true" inputId="binary"
                        [ngClass]="{'invalid': checkedTerminosCondicionesError}"></p-checkbox>
                    <span class="tandc" [ngClass]="{'invalid-text': checkedTerminosCondicionesError}"> 
                        {{ 'SPAM' | translate}}
                        <a href="#" class="customlink">{{ 'WHATSAPP_TERMS' | translate}}</a>
                    </span>
                </div>
                <ng-template pTemplate="footer">
                    <div class="row">
                        <button [disabled]="nombre === ''" pButton pRipple type="button"
                            icon="pi pi-arrow-right" label="{{ 'SAVE_CONNECT' | translate}}" iconPos="right"
                            class="p-button-raised p-button-success fR" (click)="changetab()">
                        </button>
                    </div>
                </ng-template>
                <br />
                <br />
            </p-card>
            <app-device-connect-success *ngIf="index===1"></app-device-connect-success>
        </div>

    </div>
</div>